import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes";

import { AuthProvider } from "./views/auth/AuthContext";
import { PrivateRoute, PublicOnlyRoute } from "./views/auth/Guards";
import SessionExpiredModal from "./views/auth/SessionExpiredModal"; // ← NEW
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import LandingPage from "views/landing/LandingPage";
import BookADemo from "views/landing/Components/StadoPayrollDemo";
import StadoPayrollPrivacy from "./views/landing/Components/StadoPayrollPrivacy";
import StadoPayrollTerms from "./views/landing/Components/StadoPayrollTerms";
import StadoPayrollSupport from "./views/landing/Components/StadoPayrollSupport";

const App = () => {
  return (
    <AuthProvider>
      <SessionExpiredModal /> {/* ← NEW: mounted once, invisible until token expires */}
      <Routes>

        {/* landing page */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/book-demo" element={<BookADemo />} />

        <Route path="/privacy-policy" element={<StadoPayrollPrivacy />} />
        <Route path="/terms-conditions" element={<StadoPayrollTerms />} />
        <Route path="/support" element={<StadoPayrollSupport />} />

        {/* public (only when logged OUT) */}
        <Route element={<PublicOnlyRoute />}>
          <Route path="auth/*" element={<AuthLayout />}>
            <Route
              path="sign-in"
              element={
                routes.find((r) => r.layout === "/auth" && r.path === "sign-in")
                  .component
              }
            />
          </Route>
        </Route>

        {/* private (only when logged IN) */}
        <Route element={<PrivateRoute />}>
          <Route path="admin/*" element={<AdminLayout />}>
            {routes
              .filter((r) => r.layout === "/admin")
              .map((r) => (
                <Route key={r.path} path={r.path} element={r.component} />
              ))}
          </Route>
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
